<template>
    <div>
        <el-form :inline="true" :model="form" >
          <el-form-item label="索赔单号">
            <el-input v-model="form.claimStatementId" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="索赔单提交日期">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="form.createTimeSubmit"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleQuery">查询</el-button>
          </el-form-item>
        </el-form>
        <el-table v-loading="load" :data="historyList" border stripe max-height="500">
            <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>

            <el-table-column  align="center" property="claimStatementId"  width="120" label="索赔单号">
                <template slot-scope="scope">
                    <p style="color:#409EFF;  cursor: pointer;" @click="handleDetail(scope.row)">{{ scope.row.claimStatementId }}</p>
                </template>
            </el-table-column>
          <el-table-column  align="center" property="claimStatementNum" label="订单号" width="120">
          </el-table-column>
            <el-table-column  align="center" property="auditResultDisplay" label="状态" width="100">
              <template slot-scope="scope">
                    {{ getStatus(scope.row.status) }}
                </template>
            </el-table-column>
            <el-table-column  align="center" property="customerAccount" label="客户账号" width="100"></el-table-column>
            <el-table-column  align="center" property="customerName" label="客户名称" width="120"></el-table-column>
            <el-table-column  align="center" property="vin" label="车架号" width="100">
            </el-table-column>
            
            
            <el-table-column  align="center" property="country" label="国家" width="120"></el-table-column>
            <el-table-column  align="center" property="faultPartNumber" label="配件代码" width="160"></el-table-column>
            <el-table-column  property="faultPartName" label="配件名称" width="200"></el-table-column>
            <el-table-column  property="responsibilitySupplierName" label="责任方" width="200"></el-table-column>
            <el-table-column  align="center" property="openBoxDate" label="开箱日期" width="100">
            </el-table-column>
            <el-table-column  align="center" property="createTime" label="申请时间" width="200"></el-table-column>
            <el-table-column  align="center" property="rejectNum" label="驳回次数" width="100">
            </el-table-column>
          <el-table-column  align="center" property="auditPassTime" label="正审时间" width="200"></el-table-column>
          <el-table-column  align="center" property="settlementTime" label="结算时间" width="200"></el-table-column>
        </el-table>
        <div class="fenye" v-show="total > 0">
          <pagination
            :total="total"
            :page.sync="page"
            :limit.sync="pageSize"
            @pagination="handlePaginationChange"
          />
        </div>
    </div>
</template>
<script>
import {getSession, getStorage, setStorage} from "@/util/localStor";
import { getHistoryList } from "@/api/kdsuopei";
export default {
    props:{
        claimantNum:{
            type:String,
            default:''
        },
        vin:{
            type:String,
            default:''
        },

    },
    data(){
        return {
          countryList:[],
            form:{
              claimStatementId:'',
                createTimeSubmit:''
            },
            historyList:[],
            page:1,
            pageSize:10,
            total:0,
            query:false,
            load:true,

        }
    },
  async mounted(){
    Object.values(getSession("nationList")).map(item => {
      if (item.id != 0) {
        this.countryList.push({ text: item.name, value: item.id });
      }
    });
  },

    methods:{
      // 获取国家
      getCountry(data) {
        let country = getNations(data);
        return country;
      },
      filterHandler(value, row, column) {
        const property = column["property"];
        return row[property] === value;
      },
        // 保留历史数据
        showHistoryData(){
          let obj = getStorage('history')
          this.load = false
          this.historyList = obj.list
          this.form = obj.form
          this.page=obj.page
          this.pageSize=obj.pageSize
          this.total=obj.total

        },
        // 查看
        handleDetail(data) {
        let obj = {
          show:true,
          list:this.historyList,
          claimStatementNum:this.claimantNum,
          vin:this.vin,
          form:this.form,
          page:this.page,
          pageSize:this.pageSize,
          total:this.total
        }
        setStorage("history", obj);
          localStorage.setItem('his', 2);
          this.$router.push({
            path: "/kd-claimant/preDetail",
            query: { claimantId: data.claimStatementId }
          });


        },
        // 获取索赔单状态
        getStatus(status){
            let list = [
              { label: "全部", value: "1,2,3,4,5,19,21,11,12,13,14,15,16,17,18" },
              { label: "待预审", value: "1" },
              { label: "驳回（预审）", value: "2" },
              { label: "待正审", value: "3" },
              { label: "驳回（正审）", value: "4" },
              { label: "已拒赔", value: "5" },
              { label: "待确认（责任主体）", value: "19" },
              { label: "驳回（责任确定）", value: "21" },
              { label: "待结算", value: "11" },
              { label: "已结算", value: "12" },
              { label: "已取消", value: "13" },
              { label: "已撤回", value: "14" },
              { label: "待加签(部长)", value: "15" },
              { label: "已驳回(部长)", value: "16" },
              { label: "待加签(章总)", value: "17" },
              { label: "已驳回(章总)", value: "18" }
            ]
            let str = ''
            list.map(item=>{
                if(item.value==status){
                    str = item.label
                }
            })
            return str
        },
        handleQuery(){

            this.query = true
            this.getHistoryData()
        },
        // 分页
        handlePaginationChange(val) {
          this.page = val.page;
          this.pageSize = val.limit;
          this.getHistoryData();
        },
        initData(){
            this.page = 1
            this.form = {
              claimStatementId:'',
                createTimeSubmit:''
            }
            this.total = 0
            this.historyList = []
            this.getHistoryData()
        },
        async getHistoryData(){
            this.load = true
            let data = {}
            this.query?data = {
              claimStatementNum:this.claimantNum,
              vin:this.vin,
              ...this.form
            }:data = {
              claimStatementNum:this.claimantNum,
              vin:this.vin,

            }

            let page = {
              pageNum:this.page,
              pageSize:10,
            }

          const res = await getHistoryList({data,page})
          if(res.status==0){
            this.load = false
            this.total = res.data.count
            this.historyList = res.data.records
          }
        },
    }
}
</script>
<style src="@/assets/css/qualityStyle.css"></style>
